/* eslint-disable no-nested-ternary */
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';
import QCPointActions from '@Actions/quality/qcPointActions';
import PRZSelect from '../UI/PRZSelect';

/**
 *
 */
const SelectQualityRule = ({
  getQCPoints, user, selectedQCRule, onChange, qualityControlPoints, qualityControlPointsLoading, isDisabled
}) => {

  const [qcOptions, setQcOptions] = useState([]);
  const searchRef = useRef('');
  const debounceTimeout = useRef(null);

  const tenantId = user?.tenant_info?.tenant_id;

  const debouncedSearch = useCallback((input) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      getQCPoints(tenantId, null, null, null, null, null, null, null, 1, 10, input);
    }, 300);
  }, [getQCPoints, tenantId]);

  useEffect(() => {
    getQCPoints(tenantId, null, null, null, null, null, null, null, 1, 100, '');
  }, [tenantId]);

  useEffect(() => {
    setQcOptions(qualityControlPoints?.quality_control_rules || []);
  }, [qualityControlPoints]);

  return (
    <Fragment>
      <PRZSelect
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        value={selectedQCRule}
        onChange={(value) => onChange(value)}
        onSearch={(input) => {
          searchRef.current = input;
          debouncedSearch(input);
        }}
        showSearch
        loading={qualityControlPointsLoading}
        defaultActiveFirstOption={false}
        // showArrow={false}
        style={{
          border: 'none',
          borderRadius: '2px',
          width: '97%',
          fontSize: '13px',
          height: 'auto !important',
        }}
        options={qcOptions?.map((item) => ({
          key: item?.qcr_number,
          value: item?.group_id,
          label: item?.quality_control_name,
        }))}
      />
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, QCPointReducers, ProductReducers }) => ({
  user: UserReducers.user,
  qualityControlPointsLoading: QCPointReducers.qualityControlPointsLoading,
  qualityControlPoints: QCPointReducers.qualityControlPoints,
  deleteQCPointLoading: QCPointReducers.deleteQCPointLoading,
  selectedProduct: ProductReducers.selectedProduct,
  qcPointsBySkuId: QCPointReducers.qcPointsBySkuId,
  updateQCPointProductLoading: QCPointReducers.updateQCPointProductLoading,
  getQCPointBySkuIdLoading: QCPointReducers.getQCPointBySkuIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getQCPoints: (tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword) => dispatch(
    QCPointActions.getQCPoints(tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword),
  ),
  deleteQCPoint: (payload, callback) => dispatch(QCPointActions.deleteQCPoint(payload, callback)),
  getQCPointBySkuId: (tenantId, productSkuId) => dispatch(QCPointActions.getQCPointBySkuId(tenantId, productSkuId)),
  updateQCPointProduct: (payload, callback) => dispatch(QCPointActions.updateQCPointProduct(payload, callback)),
});

SelectQualityRule.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getQCPoints: PropTypes.func,
  getQCPointBySkuId: PropTypes.func,
  updateQCPointProduct: PropTypes.func,
  updateQCPointProductLoading: PropTypes.bool,
  qualityControlPoints: PropTypes.any,
  qcPointsBySkuId: PropTypes.any,
  qualityControlPointsLoading: PropTypes.bool,
  getQCPointBySkuIdLoading: PropTypes.bool,
  selectedQCRule: PropTypes.any,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectQualityRule));
